import { Comparison } from '@/components/Smer/api/getSmerItem';
import { ArgumentItem } from './ArgumentItem';
import i18n from '@/localisation/i18n';
import { useMemo } from 'react';

export const Arguments = ({ comparison }: { comparison: Comparison }) => {
  const againstPercentage = useMemo(() => {
    return ((comparison.againstScore / comparison.commonScore) * 100).toFixed(
      0
    );
  }, [comparison.againstScore, comparison.commonScore]);

  const forPercentage = useMemo(() => {
    return ((comparison.forScore / comparison.commonScore) * 100).toFixed(0);
  }, [comparison.forScore, comparison.commonScore]);

  return (
    <div>
      <div className="flex gap-3">
        <div
          style={{
            width: `${Number(againstPercentage) < 20 ? 20 : againstPercentage}%`,
          }}
          className="flex h-6 w-full items-center justify-end rounded rounded-br-[50px] rounded-tr-[50px] bg-success pr-6 text-xs"
        >
          {comparison.againstScore} ({againstPercentage}%)
        </div>
        <div
          style={{ width: `${forPercentage || 10}%` }}
          className="flex h-6 w-full items-center justify-start rounded rounded-bl-[50px] rounded-tl-[50px] bg-error pl-6 text-xs"
        >
          {comparison.forScore} ({forPercentage}%)
        </div>
      </div>
      <div className="mt-3 block md:flex">
        {comparison.comparisonAgainst.length !== 0 && (
          <div className="collapse collapse-arrow">
            <input type="checkbox" />
            <div className="collapse-title !px-0">
              {i18n.t('arguments.against')}
            </div>
            <div className="collapse-content flex flex-col gap-2 !px-0">
              {comparison.comparisonAgainst.map(item => (
                <ArgumentItem
                  key={item.id}
                  text={item.text}
                  score={item.score}
                  isPositive={true}
                />
              ))}
            </div>
          </div>
        )}
        {comparison.comparisonAgainst.length !== 0 &&
          comparison.comparisonFor.length !== 0 && (
            <div className="divider divider-horizontal hidden md:flex"></div>
          )}
        {comparison.comparisonFor.length !== 0 && (
          <div className="collapse collapse-arrow">
            <input type="checkbox" />
            <div className="collapse-title !px-0">
              {i18n.t('arguments.for')}
            </div>
            <div className="collapse-content flex flex-col gap-2 !px-0">
              {comparison.comparisonFor.map(item => (
                <ArgumentItem
                  key={item.id}
                  text={item.text}
                  score={item.score}
                  isPositive={false}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
